import AdminLayout from "@/components/AdminLayout";
import CustomerMaster from "./CustomerMaster";

export default function CustomerMasterPage() {
  return (
    <AdminLayout>
      <div className="mb-6"><h1 className="text-3xl font-display font-bold">Customer Master</h1><p className="text-sm text-slate-500">All credit customers · codes, vehicles, discounts, limits and opening balances.</p></div>
      <CustomerMaster />
    </AdminLayout>
  );
}
